import { render, staticRenderFns } from "./MemoComponent.vue?vue&type=template&id=062ad31c&"
import script from "./MemoComponent.vue?vue&type=script&lang=ts&"
export * from "./MemoComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports